import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import FlareIcon from "@material-ui/icons/Flare";

import appRoutes from "../../../routes/app.routes";
import { NAV_LINKS } from "../homeV2.constants";
import { HomeV2Theme } from "../hooks/useTheme";
import HvButton from "./HvButton";

interface NavbarProps {
  theme: HomeV2Theme;
  onToggleTheme: () => void;
}

const Navbar = ({ theme, onToggleTheme }: NavbarProps) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`hv2-navbar ${scrolled ? "hv2-navbar--scrolled" : ""}`} role="navigation" aria-label="Main navigation">
      <div className="home-v2__container hv2-navbar__inner">
        <Link to={appRoutes.homeV2.path} className="hv2-navbar__logo">
          <span className="hv2-logo-icon" aria-hidden="true">
            <PlayArrowIcon fontSize="inherit" />
          </span>
          <span className="hv2-wordmark">
            employ<span>HER</span>
          </span>
        </Link>

        <ul
          className={`hv2-navbar__links ${mobileOpen ? "hv2-navbar__links--open" : ""}`}
          style={{ listStyle: "none" }}
        >
          {NAV_LINKS.map((link) => (
            <li key={link.label}>
              <a href={link.href} onClick={() => setMobileOpen(false)}>
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <a href="#suhavi" className="hv2-suhavi-pill" onClick={() => setMobileOpen(false)}>
              <FlareIcon fontSize="inherit" /> Suhavi AI
            </a>
          </li>
          <li className="hv2-mobile-ctas">
            <Link to={appRoutes.userLogin.path} className="hv2-navbar__login" onClick={() => setMobileOpen(false)}>
              Sign in
            </Link>
            <HvButton variant="primary" to={appRoutes.userSignUp.path} onClick={() => setMobileOpen(false)}>
              Get Started
            </HvButton>
          </li>
        </ul>

        <div className="hv2-navbar__actions">
          <button
            type="button"
            className="hv2-theme-toggle"
            aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            title="Toggle theme"
            onClick={onToggleTheme}
          >
            {theme === "dark" ? <Brightness7Icon fontSize="small" /> : <Brightness4Icon fontSize="small" />}
          </button>
          <div className="hv2-navbar__desktop-ctas">
            <Link to={appRoutes.userLogin.path} className="hv2-navbar__login">
              Sign in
            </Link>
            <HvButton variant="primary" to={appRoutes.userSignUp.path}>
              Get Started
            </HvButton>
          </div>
          <IconButton
            className="hv2-nav-toggle"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((open) => !open)}
            size="small"
          >
            {mobileOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
